import React, { useState } from "react";
import { translation } from "./Translation";

const GiftModal = (props) => {
    const [lang, setLang] = useState(localStorage.getItem("lang") || "fa");
    return (
        <div className="wallet-main gift">
            <div className="wallet-modal">
                <h2>
                    <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M21.6341 10.8333H4.30078V19.5C4.30078 22.75 5.38411 23.8333 8.63411 23.8333H17.3008C20.5508 23.8333 21.6341 22.75 21.6341 19.5V10.8333Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M23.2917 7.58333V8.66666C23.2917 9.85833 22.7175 10.8333 21.125 10.8333H4.87504C3.21754 10.8333 2.70837 9.85833 2.70837 8.66666V7.58333C2.70837 6.39166 3.21754 5.41666 4.87504 5.41666H21.125C22.7175 5.41666 23.2917 6.39166 23.2917 7.58333Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.4"
                            d="M12.6101 5.41666H6.63005C6.26172 5.01583 6.27255 4.39833 6.66255 4.00833L8.20089 2.47C8.60172 2.06916 9.26255 2.06916 9.66339 2.47L12.6101 5.41666Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.4"
                            d="M19.3592 5.41666H13.3792L16.3258 2.47C16.7266 2.06916 17.3875 2.06916 17.7883 2.47L19.3266 4.00833C19.7166 4.39833 19.7275 5.01583 19.3592 5.41666Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.4"
                            d="M9.68506 10.8333V16.4017C9.68506 17.2683 10.6384 17.7775 11.3642 17.3117L12.3826 16.64C12.7509 16.4017 13.2167 16.4017 13.5742 16.64L14.5384 17.29C15.2534 17.7667 16.2176 17.2575 16.2176 16.3908V10.8333H9.68506Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    {translation.Products_complimentary[lang]
                        ? translation.Products_complimentary[lang]
                        : "اشانتیون"}
                </h2>
                <div className="accordion-cus">
                    {props.gift && props.gift.length !== 0
                        ? props.gift.map((item) => {
                              return item.details.map((ii) => {
                                  return (
                                      <div className="option">
                                          <input
                                              id="toggle2"
                                              className="toggle"
                                          />
                                          <label
                                              className="title"
                                              for="toggle2"
                                          >
                                              {ii && ii && ii.goodsDetail
                                                  ? "به ازای هر " +
                                                    ii.orderCount +
                                                    " عدد سفارش " +
                                                    ii.giftCount +
                                                    " عدد " +
                                                    ii.goodsDetail.name
                                                  : " به ازای هر " +
                                                    ii.orderCount +
                                                    " عدد سفارش " +
                                                    ii.giftCount +
                                                    " درصد از کل فاکتور "}
                                          </label>
                                      </div>
                                  );
                              });
                          })
                        : "محصول اشانتیون ندارد"}
                </div>
            </div>
        </div>
    );
};

export default GiftModal;
